

define(['squid/index', 'text!./template.html', 'components/xo-ui-components/src/tooltip/directive'], function (squid, template) {
    squid.module('xo-dob-nationalid.directive', ['squid', 'xo-tooltip.directive']).directive('xoDobNationalid', function () {
        var padNumber = function padNumber(num) {
            return num.toString().replace(/^(\d)$/, '0$1');
        };
        /**
         * Create an array from a start and end number.
         * @param  {Number} start
         * @param  {Number} end
         * @return {Array}
         */
        var getRange = function getRange(start, end) {
            var arr = [];
            // decide how this array shall be sorted
            if (start < end) {
                for (; start <= end; start++) {
                    arr.push(padNumber(start));
                }
            } else {
                for (; start >= end; start--) {
                    arr.push(padNumber(start));
                }
            }
            return arr;
        };

        return {
            template: template,
            scope: {
                pi: '='
            },

            controller: function controller($scope) {

                $scope.init = function () {
                    var thisYear = new Date().getFullYear();
                    $scope.days = getRange(1, 31);
                    $scope.months = getRange(1, 12);
                    $scope.years = getRange(thisYear - 18, thisYear - 110);
                };
                $scope.init();
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/dob-nationalid/directive.js
// module id = ./components/xo-form-components/src/dob-nationalid/directive.js
// module chunks = 1